<template>
    <projeto-resultados 
        :projeto-id="projetoIdBase" 
        :titulo="titulo" 
        :colunas="colunas" 
        :rubrica="rubrica" 
        :componente="componente" 
        :endpoint="endpoint" 
        @update="update"

        :chave-permissao="chavePermissao"
        :projeto-editavel="projetoEditavel"
    />
</template>
<script>
import helpers from "@/common/utils/helpers";
import ProjetoResultados from "../componentes/Resultados"
export default {
    components : {
        ProjetoResultados
    },
    props : ['projetoId', 'projetoIdBase', 'endpoint', 'chavePermissao', 'projetoEditavel'],
    data : () => ({
        colunas : [
            { key: "empresa", label: "Empresa", },                            
            { key: 'tipo', label: "Tipo de laboratório",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            { key: "laboratorio", label: "Nome do laboratório", },
            { key: "areaPesquisa", label: "Área de pesquisa", },
            { key: "listaMateriais", label: "Materiais de apoio", },
        ],
        componente : 'apoio-infraestrutura',
        rubrica : 'apoio-infraestrutura',
        titulo : 'Apoio à Infraestrutura',
    }),
    methods : {
        update : function(){
            this.$emit('update');
        }
    }
}
</script>
<style>
    
</style>